import { FOOTER_COLUMNS } from 'constants/Footer/Columns.const';
import { useAppLinkAccess } from 'hooks/useAppLinkAccess';
import { Trans, useTranslation } from 'react-i18next';
import * as S from './styles';

export default function Footer() {
  const { t } = useTranslation('translation', { keyPrefix: 'footer' });
  const { resolveAppUrl } = useAppLinkAccess();

  return (
    <S.Root>
      <S.Container>
        <S.Logo />
        <S.ColumnList>
          {FOOTER_COLUMNS.map(({ title, items }) => (
            <S.Column key={title}>
              <S.ColumnTitle>
                <S.Text>{t(title)}</S.Text>
              </S.ColumnTitle>
              <S.Divider />
              {items.map(({ text, url, allowedSystem, onClick, icon, small }) => {
                const IconComponent = icon ? S[icon] : null;
                const href =
                  allowedSystem !== undefined
                    ? resolveAppUrl(allowedSystem, url)
                    : url;

                return (
                  <S.ColumnItem key={text}>
                    {href || onClick ? (
                      <S.Link href={href} onClick={onClick} target="_blank">
                        <S.Text $small={small}>{t(text)}</S.Text>
                        {icon && <IconComponent />}
                      </S.Link>
                    ) : (
                      <S.Text $small={small}>{t(text)}</S.Text>
                    )}
                  </S.ColumnItem>
                );
              })}
            </S.Column>
          ))}
          <S.Column>
            <S.ColumnTitle>
              <S.Text>{t('auctions')}</S.Text>
            </S.ColumnTitle>
            <S.Divider />
            <S.ColumnItem>
              <S.Text>{t('auctionTime1')}</S.Text>
            </S.ColumnItem>
            <S.ColumnItem>
              <S.Text>{t('auctionTime2')}</S.Text>
            </S.ColumnItem>
            <S.ColumnItem>
              <S.Text $small>
                <Trans
                  t={t}
                  i18nKey="noAuction"
                  components={{
                    bold: <S.Bold />,
                  }}
                />
                <br />
                <br />
                <Trans
                  t={t}
                  i18nKey="warningAge"
                  components={{
                    bold: <S.Bold />,
                  }}
                />
              </S.Text>
            </S.ColumnItem>
          </S.Column>
        </S.ColumnList>
        <S.Divider />
        <S.BottomFooter>
          <S.VhLogo />
          <S.Address>
            <S.Text>
              <Trans
                t={t}
                i18nKey="veilingHolambraCooperative"
                components={{
                  bold: <S.Bold />,
                }}
              />
            </S.Text>
            <S.Text>{t('address')}</S.Text>
          </S.Address>
          <S.Socials>
            <S.SocialIg
              href="https://www.instagram.com/veilingholambra"
              target="_blank"
            />
            <S.SocialFb
              href="https://www.facebook.com/veilingholambrabrasil"
              target="_blank"
            />
          </S.Socials>
        </S.BottomFooter>
      </S.Container>
    </S.Root>
  );
}
